import { useState } from 'react';
import type { EntityState } from '../../lib/api.js';
import { useDevices } from '../../context/DevicesContext.js';
import { Button } from '../ui/Button.js';
import { friendlyName } from '../../lib/utils.js';
import { useToast } from '../ui/Toast.js';

interface Props {
  entityId: string;
  entity: EntityState;
}

export function LockCard({ entityId, entity }: Props) {
  const { sendCommand, patchEntity } = useDevices();
  const toast = useToast();
  const locked = entity.state === 'locked';
  const [pending, setPending] = useState(false);

  const handleToggle = async () => {
    const prev = entity;
    const next = locked ? 'unlocked' : 'locked';
    patchEntity(entityId, { ...entity, state: next });
    setPending(true);
    try {
      await sendCommand('lock', locked ? 'unlock' : 'lock', entityId);
    } catch {
      patchEntity(entityId, prev);
      toast.show('Command failed', 'error');
    } finally {
      setPending(false);
    }
  };

  return (
    <div
      className="p-4 rounded-xl border flex items-center justify-between"
      style={{ backgroundColor: 'var(--ac-surface)', borderColor: 'var(--ac-border)' }}
    >
      <div>
        <div className="font-medium text-[var(--ac-text)]">
          {friendlyName(entityId, entity.attributes)}
        </div>
        <div className="text-xs text-[var(--ac-text-muted)]">{locked ? 'Locked' : 'Unlocked'}</div>
      </div>
      <Button variant="secondary" onClick={handleToggle} disabled={pending}>
        {locked ? 'Unlock' : 'Lock'}
      </Button>
    </div>
  );
}
